// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1___aba6e79da4ddf56a69a","cls2":"ProfileFeed-cls2___d45a371a68a9d066b33 ProfileFeed-cls1___aba6e79da4ddf56a69a"};